import { Component, OnInit, ViewChild } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal/modal-options.class';
import { ToastrService } from 'ngx-toastr';
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import { DateRangePickerOptions } from 'app/_helpers/date-range-picker-options';
import { DaterangepickerConfig } from 'ng2-daterangepicker';
import { ReportService } from 'app/_services/report.service';
import { BaseChartDirective } from 'ng2-charts';
import { Subscription } from 'rxjs';
import { ReportLoadingService } from 'app/_services/report-loading.service';
import { SmmService } from 'app/_services/smm.service';
import { ProjectsService } from 'app/_services/projects.service';

const moment = require('moment');
@Component({
  selector: 'app-projects-list',
  templateUrl: './post-negative.component.html',
  styleUrls: ['./post-negative.component.scss']
})
export class PostNegativeComponent implements OnInit {

  @ViewChild('baseLineChart') baseLineChart: BaseChartDirective;

  public posts = Array();
  public projectDetail = {};
  public daterange: any = {
    start: moment().subtract(7, "days").startOf('day'),
    end: moment().endOf('day')
  };

  options: any = {
    locale: { format: 'DD/MM/YYYY HH:mm:ss' },
    timePicker: true,
    timePicker24Hour: true,
    timePickerSeconds: true,
    alwaysShowCalendars: false,
    maxDate: moment().endOf('day').toDate(),
    startDate: this.daterange.start,
    endDate: this.daterange.end
  };

  selectedDate(value: any, datepicker?: any) {
    datepicker.start = value.start;
    datepicker.end = value.end;
    this.daterange.start = value.start;
    this.daterange.end = value.end;
    this.daterange.label = value.label;
  }
  projectDropDownSettings = {
    singleSelection: false,
    text: 'Chọn chủ đề',
    selectAllText: 'Chọn tất cả',
    unSelectAllText: 'Bỏ chọn tất cả',
    enableSearchFilter: false,
    badgeShowLimit: 2,
  };
  public projectSelected = Array();
  projects = Array();
  defaultProjects = Array();

  typeTimeDropDownSettings = {
    singleSelection: true,
    text: 'Chọn độ trễ thời gian chưa xử lý',
    selectAllText: 'Chọn tất cả',
    unSelectAllText: 'Bỏ chọn tất cả',
    enableSearchFilter: false,
    badgeShowLimit: 2,
  };

  typeTimeSelected = [
    { id: "0", itemName: "Tất cả", value: "Tất cả" }
  ];
  typeTimes = [
    { id: "0", itemName: "Tất cả", value: "Tất cả" },
    { id: "10", itemName: "<= 10 phút", value: "<= 10 phút" },
    { id: "20", itemName: "<= 20 phút", value: "<= 20 phút" },
    { id: "30", itemName: "<= 30 phút", value: "<= 30 phút" },
    { id: "999", itemName: "> 30 phút", value: "> 30 phút" }
  ];

  tab: string = 'post';

  public content = "";
  public source = "";
  public isBussinessCenter = false;
  public filter = {};


  public currentProject;
  public currentAccount;
  dtOptions: DataTables.Settings = {};
  bsConfig: Partial<BsDatepickerConfig>;
  public dataTableShow: Object = false;
  modalRef: BsModalRef;
  modalRef1: BsModalRef;
  sourceByTopic = "";
  public config2 = {
    keyboard: false,
    backdrop: 'static',
    class: 'modal-lg'
  };
  public config1 = {
    keyboard: false,
    backdrop: 'static',
    class: 'modal-sm'
  };

  public view;

  public chartHovered(e: any): void {
  }

  isLoading: Boolean;
  subscription: Subscription;

  constructor(
    private dateRangePickerOptions: DaterangepickerConfig,
    private toastrService: ToastrService,
    private postService: SmmService,
    private reportService: ReportService,
    private projectsService: ProjectsService,
    private reportLoadingService: ReportLoadingService
  ) {
    this.dateRangePickerOptions.settings = DateRangePickerOptions.settingReportFilter;
    this.currentAccount = localStorage.getItem('currentSmmAccount') ?
      JSON.parse(localStorage.getItem('currentSmmAccount')) : {};

    this.subscription = this.reportLoadingService.getData().subscribe(isLoading => {
      this.isLoading = isLoading;
    }, (err) => { console.log(err) });
  }

  ngOnInit(): void {
    this.bsConfig = Object.assign({}, {
      containerClass: 'theme-blue',
    });
    this.dataTableShow = true;
    this.dtOptions = {
      pagingType: 'full_numbers',
      serverSide: false,
      paging: true,
      searching: false,
      ordering: true,
      language: {
        info: 'Hiển thị _START_ - _END_ trên _TOTAL_',
        infoEmpty: 'Không tìm thấy dữ liệu phù hợp',
        infoFiltered: '(trong _MAX_)',
        lengthMenu: 'Hiển thị _MENU_',
        search: 'Tìm kiếm',
        zeroRecords: 'Không có dữ liệu',
      }
    };

    this.loadDataByProject();
  };

  loadDataByProject() {
    this.projectsService.index().subscribe(response => {
      if (response.success) {
        response.data.projects.forEach(element => {
          let obj = {
            id: element._id,
            itemName: element.name,
            value: element.name
          };
          this.projects.push(obj);
        });
        this.loadDefaultProjects();
        this.loadData();
      }
    });
  }

  loadDefaultProjects() {
    let defaultProjectsStr = 'vnpt|my tv|vinaphone|mnp_ chuyển mạng giữ số|chất lượng điện thoại viên|vnpt pay|khách hàng doanh nghiệp';
    this.defaultProjects = this.projects.filter(item => {
      if(defaultProjectsStr.includes(item.value.toLowerCase())) {
        return true;
      }
    });
  }

  loadData() {
    this.dataTableShow = false;
    this.isLoading = true;
    this.posts = [];
    this.projectSelected = (this.projectSelected.length > 0) ? this.projectSelected : JSON.parse(JSON.stringify(this.defaultProjects));

    if (this.projectSelected.length == 0) {
      this.toastrService.error("Bạn phải chọn ít nhất 1 chủ đề!", "Thông báo!");
    }
    this.filter = {
      gte: this.daterange.start.valueOf(),
      lte: this.daterange.end.valueOf(),
      project: this.projectSelected,
      typeTimeSelected: this.typeTimeSelected,
      sourceByTopic: this.sourceByTopic
    };
    let callApi = null;
    if(this.tab == 'post') {
      callApi = this.postService.searchPostNegative({ filter: this.filter });
    }
    else {
      callApi = this.postService.searchCommentNegative({ filter: this.filter });
    }

    callApi.subscribe(response => {
      if (response.success && response.data.hits) {
        this.projectDetail = response.quickResearchProject;
        this.posts = response.data.hits.hits;
        for (var i = 0; i < this.posts.length; i++) {
          this.posts[i]['_source']['linkSl'] = this.getLinkSocial(this.posts[i], this.projectSelected);
          this.posts[i]['_source']['projectNegs'] = this.getProjectSentiment(this.posts[i], this.projectSelected);
          this.posts[i]['_source']['createDate'] = this.formatDate(this.posts[i]['_source']['createDate']);
          this.posts[i]['_source']['collectDate'] = this.formatDate(this.posts[i]['_source']['collectDate']);
        }
        //line chart
        this.dataTableShow = true;
      }
      this.isLoading = false;
    });
  }

  formatDate(dateField) {
    var date = new Date(dateField);
    var dateStr =
      ("00" + date.getDate()).slice(-2) + "/" +
      ("00" + (date.getMonth() + 1)).slice(-2) + "/" +

      date.getFullYear() + " " +
      ("00" + date.getHours()).slice(-2) + ":" +
      ("00" + date.getMinutes()).slice(-2) + ":" +
      ("00" + date.getSeconds()).slice(-2);
    return dateStr;
  }

  getLinkSocial(post, projectFilter) {
      let projects = post['_source'].topicSentiment;
      // let link = ServiceConfig.host.includes('vnsocial') ? "http://vnsocial.vnptmedia.vn" : "https://vnhearing.vnptmedia.vn";
      let link = window.location.hostname;
      link = link == 'localhost' ? link + ':4200' : link;
      link = window.location.protocol + '//' + link;

      for (var i = 0; i < projects.length; i++) {
        for (var j = 0; j < projectFilter.length; j++) {

          if (projectFilter[j].id == projects[i].id && projects[i].sentiment == "neg") {
            if(post['_source']['docType'] != 'comment') {
              link += "/project/" + projects[i].id + "/posts?docId=" + post['_id']
                + "&postIndex=" + post['_index'];
            }
            else {
              link += "/project/" + projects[i].id + "/posts?docId=" + post['_source']['postId']
                + "&postIndex=" + post['_source']['postIndex'] + "&commentId=" + post['_source']['docId'];
            }
            return link;
          }
        }
      }
      return link;
  };

  getProjectSentiment(post, projectFilter) {

      let projects = post['_source'].topicSentiment;
      let projectSentiment = Array();
      for (var i = 0; i < projectFilter.length; i++) {
        for (var j = 0; j < projects.length; j++) {
          if (projectFilter[i].id == projects[j].id && projects[j].sentiment == "neg") {
            projectSentiment.push(projects[j].topic);
          }
        }
      }
      return projectSentiment;
  };
  //xuat bao cao
  exportData() {
    if (this.posts.length == 0) {
      this.toastrService.error("Không có dữ liệu để xuất báo cáo!", "Thông báo!");
    } else {
      let data = Array();
      for (var i = 0; i < this.posts.length; i++) {
        let linkSource = (this.posts[i]['_source'].docType == 'page_post' || this.posts[i]['_source'].docType == 'user_post' || this.posts[i]['_source'].docType == 'group_post') ? ("https://facebook.com/" + this.posts[i]['_id']) : this.posts[i]['_source'].link;
        let obj = {
          content: this.posts[i]["_source"].message || this.posts[i]["_source"].content || this.posts[i]["_source"].title,
          likes: this.posts[i]["_source"].numLikes || "-",
          comments: this.posts[i]["_source"].numComments || "-",
          shares: this.posts[i]["_source"].numShares || "-",
          projectNegs: (this.posts[i]["_source"].projectNegs) ? this.posts[i]["_source"].projectNegs.join(", ") : "-",
          source: (this.posts[i]["_source"].sourceName || this.posts[i]["_source"].channelTitle) + "  " + moment(this.posts[i]["_source"].createDate).format('DD/MM/YYYY h:mm:ss a'),
          linkSource: linkSource,
          linkSocial: this.posts[i]["_source"]["linkSl"]
        };
        data.push(obj);
      }
      let headerDetailContentReport1 = [{ start: 1 }, { name: "STT" }, { name: "Nội dung" }, { name: "Lượt thích" }, { name: "Lượt bình luận" }, { name: "Lượt chia sẻ" }, { name: "Chủ đề" }, { name: "Tạo bởi" }, { name: "Link bài gốc" }, { name: "Link Social" }];
      let objDetailContentReport = { name: "Danh sách bài viết tiêu cực chưa xử lý", header: [headerDetailContentReport1], data: data };
      let dataExport = Array();
      dataExport.push(objDetailContentReport);
      this.isLoading = true;
      this.reportService.exportReportToExcel(dataExport);
    }
  }
  closeModal() {
    this.modalRef.hide();
  }
  changeTab(tab: string) {
    this.tab = tab;
    this.loadData();
  }
}



// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/views/post-negative/post-negative.component.ts